export default __webpack_public_path__ + "static/media/PR@3x.71f60d46.png";